<template lang="pug">
    div(class="pt-2" @click="openTradePlanPopup()")
        div(v-if="tradePlans.length > 0")
            div(class="d-flex" v-if="fromChart")
                span(v-if="today <= tradePlanLatestExpires.entry_date && bellActive"  style="width: 90px;")
                    v-icon $bellActive
                    span(class="green1--text ml-4") {{ riskRatio }}

                span(v-else-if="today > tradePlanLatestExpires.entry_date" style="position: relative;")
                    v-tooltip(bottom)
                        template(v-slot:activator="{ on, attrs }")
                            div(v-bind="attrs" v-on="on" style="padding-bottom: 14px;")
                                span(style="position: absolute;width: 90px;")
                                    v-icon $bellExpired
                                    span(class="green1--text ml-4") {{ riskRatio }}
                        span {{ $t('date_expired') }}

                span(v-else-if="targetPriceFired || entryPriceFired || stoplossPriceFired"  style="width: 90px;")
                    v-icon $bellAlarm
                    span(class="green1--text ml-4") {{ riskRatio }}

                span(v-else-if="bellInactive"  style="width: 90px;")
                    v-icon $bellExpired
                    span(class="ml-4") {{ riskRatio }}

        div(v-else)
            div(class="d-flex" style="position: relative;")
                v-tooltip(bottom)
                    template(v-slot:activator="{ on, attrs }")
                        div(v-bind="attrs" v-on="on" style="padding-bottom: 14px;")
                            span(style="position: absolute;width: 60px;")
                                v-icon $bellNotAdded
                    span {{ $t('create_new_trade_plan') }}
</template>

<script>
import { mapMutations } from 'vuex';
import moment from 'moment';
import _ from 'lodash';

export default {
    name: 'TradePlanState',
    data: function() {
        return {
            stock_id: null,
            stock: null,
            fromChart: true
        }
    },
    mounted() {
        if (this.params) {
            this.stock_id = this.params.data.stock_id;
            this.stock = this.params.data;
        }
    },
    methods: {
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        openTradePlanPopup() {
            this.$parent.$parent.stock_id = this.stock_id;

            setTimeout(() => {
                this.$parent.$parent.showTradePlanPopup = true;
            }, 50);
        }
    },
    computed: {
        riskRatio() {
            return Math.round((this.tradePlanLatestExpires.target_price - this.tradePlanLatestExpires.entry_price) * 10 / (this.tradePlanLatestExpires.entry_price - this.tradePlanLatestExpires.stoploss_price)) / 10;
        },
        tradePlanLatestExpires() {
            // Do this if getting values from the trade plan
            // that has the latest entry_date
            const tradePlans = _.orderBy(this.tradePlans, ['entry_date'], ['desc']);

            const dateNow = new Date().toISOString().slice(0,10);
            const dateTwoWeeksLater = moment(dateNow).add(14, 'day').format('YYYY-MM-DD');

            const targetPrice = (this.stock.price_today * 1.1).toFixed(2);
            const entryPrice = (this.stock.price_today * 1).toFixed(2);
            const stoplossPrice = (this.stock.price_today * 0.9).toFixed(2);
            const exitDate = dateNow;
            const entryDate = dateTwoWeeksLater;

            const tradePlanObject = {
                user_id: this.user.user_id,
                stock_id: this.stock.stock_id,
                entry_date: entryDate,
                exit_date: exitDate,
                long: true,
                target_price: targetPrice,
                entry_price: entryPrice,
                stoploss_price: stoplossPrice,
                stoploss_alert_status: 'on',
                entry_alert_status: 'on',
                target_alert_status: 'on'
            };

            return  (tradePlans.length > 0) ? tradePlans[0] : tradePlanObject;
        },
        tradePlans() {
            return this.$store.getters["userTradePlans"].filter((item) => item.stock_id === this.stock_id && item.user_id === this.user.user_id);
        },
        targetPriceFired() {
            return this.tradePlanLatestExpires.target_alert_status === 'fired';
        },
        entryPriceFired() {
            return this.tradePlanLatestExpires.entry_alert_status === 'fired';
        },
        stoplossPriceFired() {
            return this.tradePlanLatestExpires.stoploss_alert_status === 'fired';
        },
        user() {
            return JSON.parse(localStorage.getItem('user'));
        },
        today() {
            return new Date().getTime();
        },
        bellInactive() {
            return this.tradePlanLatestExpires.target_alert_status === 'off' && this.tradePlanLatestExpires.entry_alert_status === 'off' && this.tradePlanLatestExpires.stoploss_alert_status === 'off';
        },
        bellActive() {
            return this.tradePlanLatestExpires.target_alert_status === 'on' && this.tradePlanLatestExpires.entry_alert_status === 'on' && this.tradePlanLatestExpires.stoploss_alert_status === 'on';
        }
    }
}
</script>

<style scoped>
>>> .set-bell-not-added-color {
    fill: #081016;
}

>>> .set-bell-active-color {
    fill: #009973;
}

>>> .set-bell-expired-color {
    fill: #8b9daf;
}

>>> .set-bell-alarm-color {
    fill: #E83068;
}

>>> .set-bell-not-added-color {
    fill: #d1d0d0;
}
</style>
